import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TransportOptionCondition } from '../../../transport-options.model';
import { TransportOptionsAdministrationContext } from '../../../transport-options-administration.context';

@Component({
  selector: 'yard-condition-editor',
  standalone: false,
  templateUrl: './condition-editor.component.html',
  styleUrl: './condition-editor.component.scss',
})
export class ConditionEditorComponent {

  @Output() deleteRequested = new EventEmitter<void>();

  condition: TransportOptionCondition;
  @Input('condition') set setCondition(value: TransportOptionCondition) {
    this.condition = value;
  }

  @Input() context: TransportOptionsAdministrationContext;

  onDictionaryChanged() {
    if (this.context) {
      this.context.dirty = true;
    }
  }
}
